import { createAtomObserver } from '@exodus/atoms';
import type { Definition } from '@exodus/dependency-types';
import type Emitter from '@exodus/wild-emitter';

import type { BlinkActionsAtom } from './atoms/actions.js';
import type { AppsAtom } from './atoms/apps.js';
import { ACTIONS_EVENT, APPS_EVENT } from './constants.js';
import type { Blinks } from './module.js';

type Dependencies = {
  port: Emitter;
  blinks: Blinks;
  blinkActionsAtom: BlinkActionsAtom;
  appsAtom: AppsAtom;
};

const createBlinksPlugin = ({
  port,
  blinks,
  blinkActionsAtom,
  appsAtom,
}: Dependencies) => {
  const observers = [
    createAtomObserver({
      atom: blinkActionsAtom,
      port,
      event: ACTIONS_EVENT,
    }),
    createAtomObserver({
      atom: appsAtom,
      port,
      event: APPS_EVENT,
    }),
  ];

  return {
    onLoad: () => {
      observers.forEach((observer) => observer.start());

      blinks.loadApps();
    },
    onStop: () => {
      observers.forEach((observer) => observer.unregister());
    },
  };
};

const blinksPluginDefinition = {
  id: 'blinksPlugin',
  type: 'plugin',
  factory: createBlinksPlugin,
  dependencies: ['port', 'blinkActionsAtom', 'blinks', 'appsAtom'],
} as const satisfies Definition;

export default blinksPluginDefinition;
